export default {
  title: 'ค่าส่วนกลาง',
  new_fee: 'เพิ่มค่าธรรมเนียม',
  edit_fee: 'แก้ไขค่าธรรมเนียม',
  description: 'จัดการกองทุนบำรุงรักษา กองทุนจม ประกันภัย และค่าส่วนกลางอื่นๆ',

  labels: {
    name: 'ชื่อค่าธรรมเนียม',
    fee_type: 'ประเภทค่าธรรมเนียม',
    calculation_method: 'วิธีคำนวณ',
    rate: 'อัตรา (฿)',
    vat_rate: 'อัตราภาษีมูลค่าเพิ่ม (%)',
    effective_from: 'มีผลตั้งแต่',
    effective_until: 'มีผลถึง',
    description: 'รายละเอียด',
    status: 'สถานะ',
    total_amount: 'ยอดรวม',
    unit_number: 'ห้อง',
    area_sqm: 'พื้นที่ (ตร.ม.)',
    share_ratio: 'สัดส่วนพื้นที่',
    calculated_amount: 'ยอดเงิน (฿)',
  },

  placeholders: {
    name: 'เช่น กองทุนบำรุงรักษาประจำปี',
    rate: '0.00',
    vat_rate: '7',
    description: 'รายละเอียดเพิ่มเติม (ไม่บังคับ)',
  },

  fee_types: {
    maintenance_fund: 'กองทุนบำรุงรักษา',
    sinking_fund: 'กองทุนจม',
    insurance: 'ประกันภัย',
    other: 'อื่นๆ',
  },

  calculation_methods: {
    per_unit: 'ต่อห้อง (อัตราคงที่)',
    per_sqm: 'ต่อตารางเมตร',
    per_share_ratio: 'ตามสัดส่วนพื้นที่',
    fixed_amount: 'จำนวนคงที่ (รวม)',
  },

  status: {
    active: 'ใช้งาน',
    expired: 'หมดอายุ',
    upcoming: 'กำลังจะมีผล',
  },

  actions: {
    add_fee: 'เพิ่มค่าธรรมเนียม',
    preview: 'ดูรายละเอียดรายห้อง',
    hide_preview: 'ซ่อนรายละเอียด',
  },

  preview: {
    title: 'รายละเอียดการคำนวณรายห้อง',
    description: 'คำนวณจากข้อมูลห้องปัจจุบันและค่าธรรมเนียมที่กำหนดข้างต้น',
    loading: 'กำลังคำนวณ...',
    empty: 'ไม่พบห้องในอสังหาริมทรัพย์นี้',
    total: 'ยอดรวม',
    units_count: '{{count}} ห้อง',
  },

  messages: {
    created: 'สร้างค่าส่วนกลางสำเร็จ',
    updated: 'แก้ไขค่าส่วนกลางสำเร็จ',
    deleted: 'ลบค่าส่วนกลางสำเร็จ',
    delete_confirm: 'ลบค่าธรรมเนียม "{{name}}"?',
    no_fees: 'ยังไม่มีค่าส่วนกลาง',
    no_fees_description: 'เพิ่มค่าธรรมเนียม เช่น กองทุนบำรุงรักษา กองทุนจม หรือประกันภัย',
    condominium_only: 'ค่าส่วนกลางใช้ได้เฉพาะอสังหาริมทรัพย์ประเภทคอนโดมิเนียม',
    share_ratio_warning: 'ผลรวมสัดส่วนพื้นที่ไม่เท่ากับ 1.0 รวม: {{total}}',
    missing_sqm_warning: 'ห้องบางห้องไม่มีข้อมูลพื้นที่ (ตร.ม.)',
    missing_ratio_warning: 'ห้องบางห้องไม่มีข้อมูลสัดส่วนพื้นที่',
  },

  validation: {
    name_required: 'กรุณากรอกชื่อค่าธรรมเนียม',
    fee_type_required: 'กรุณาเลือกประเภทค่าธรรมเนียม',
    calculation_method_required: 'กรุณาเลือกวิธีคำนวณ',
    rate_required: 'กรุณากรอกอัตรา',
    rate_positive: 'อัตราต้องเป็นจำนวนบวก',
    effective_from_required: 'กรุณากรอกวันที่มีผล',
    vat_rate_range: 'อัตราภาษีมูลค่าเพิ่มต้องอยู่ระหว่าง 0 ถึง 100',
  },

  // EP-111 T111-8 — หน้าค่าส่วนกลางในเมนูด้านข้าง (สไตล์เดียวกับหน้าจดมิเตอร์)
  rates_page: {
    title: 'ค่าส่วนกลาง',
    description: 'ดูอัตราปัจจุบัน รายละเอียดรายห้อง และประวัติอัตราค่าส่วนกลางของแต่ละคอนโดมิเนียม',
    property_label: 'อสังหาริมทรัพย์',
    set_new_rate: 'กำหนดอัตราใหม่',
    save_rate: 'บันทึกอัตรา',
    new_effective_from: 'มีผลตั้งแต่วันที่',
    set_rate_success: 'กำหนดอัตราใหม่สำเร็จ',
    superseding_context: 'กำลังกำหนดอัตราใหม่สำหรับ "{{name}}" ({{method}}) อัตราเดิมจะปิดโดยอัตโนมัติในวันก่อนอัตราใหม่มีผล',
    method_context: '{{fee_type}} · {{method}} · ภาษีมูลค่าเพิ่ม {{vat}}%',
    open: 'ใช้งานอยู่',
    closed: 'ปิดแล้ว',
    effective_since: 'มีผลตั้งแต่ {{date}}',
    no_active_rate: 'ยังไม่มีอัตราที่ใช้งานอยู่สำหรับค่าธรรมเนียมชุดนี้',
    per_unit_breakdown: 'รายละเอียดรายห้อง',
    rate_history: 'ประวัติอัตรา',
    no_condo_properties_title: 'ยังไม่มีอสังหาริมทรัพย์ประเภทคอนโดมิเนียม',
    no_condo_properties_description: 'ตั้งค่าประเภทอสังหาริมทรัพย์เป็นคอนโดมิเนียมในแท็บภาพรวมก่อน จึงจะจัดการอัตราค่าส่วนกลางที่นี่ได้',
    no_fees_configured_title: 'ยังไม่ได้ตั้งค่าค่าส่วนกลาง',
    no_fees_configured_description: 'เพิ่มประเภทค่าธรรมเนียมและวิธีคำนวณในแท็บค่าส่วนกลางของอสังหาริมทรัพย์นี้ก่อน จากนั้นจึงจัดการอัตราได้ที่นี่',
    configure_on_caf_tab: 'ตั้งค่าค่าส่วนกลาง',
    zero_area_warning: 'ไม่ได้ระบุพื้นที่ จะถูกข้ามในใบแจ้งหนี้',
    zero_ratio_warning: 'ไม่ได้ระบุสัดส่วนพื้นที่ จะถูกข้ามในใบแจ้งหนี้',
  },
}
